import { v4 } from 'uuid';

import { PanelItemGroupDataIn } from './types';
import { RecordData } from '../../helpers-classes';

export const panelItemGroupData = (dataIn: PanelItemGroupDataIn = null): PanelItemGroupDataIn => {
	const rd = new RecordData<PanelItemGroupDataIn>(dataIn);

	const record: PanelItemGroupDataIn = {
		id: rd.useNewOrPartial<string>('id', v4()),
		items: dataIn?.items ?? null,
		center: dataIn?.center ?? null,
		showCenterDimension: rd.useNewOrDefault('showCenterDimension', true),
		positionLocked: rd.useNewOrDefault('positionLocked', false),
		fineTuned: rd.useNewOrDefault('fineTuned', false)
	}

	return record;
};
